import React from 'react';
import { TableRow, TableCell, TooltipIcon } from 'carbon-components-react';
import {
  Automatic16,
  Hourglass16,
  CheckmarkOutline16,
  Folder16,
  ViewOff16,
  CloseOutline16
} from '@carbon/icons-react';
import { toLocalDateFormat } from 'utilities/helper.util';

const DisplayEnquiryRow: React.FC<any> = ({
  row,
  getRowProps,
  handleSetEnquiryId,
  smallscreen,
  selectedRow
}) => {
  const { REACT_APP_SENTINEL_RESPONSE_COLLATION } = process.env;

  return (
    <TableRow
      {...getRowProps({ row, smallscreen })}
      onClick={() =>
        handleSetEnquiryId(row.id, row.isDataRotated, row.isLimitedReached)
      }
      isSelected={selectedRow === row.id}
    >
      {smallscreen === 'true' ? (
        <TableCell
          key={`${row.id}-small`}
          className={
            row.isExpired && REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true'
              ? 'expired-row'
              : ''
          }
        >
          {REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true' && (
            <div className="jobId-row">{`Job ${row.jobId} (${row.userReference})`}</div>
          )}
          {REACT_APP_SENTINEL_RESPONSE_COLLATION === 'true' && (
            <div className="jobId-row-sm">
              {`Job ${row.jobId} (${row.userReference})`}
              {(row.autoRenew || (!row.internalCreate && row.autoRenewUntil)) &&
              REACT_APP_SENTINEL_RESPONSE_COLLATION === 'true' ? (
                <TooltipIcon
                  tooltipText={`Auto-renews until ${toLocalDateFormat(
                    row.autoRenewUntil
                  )}`}
                  align={'start'}
                >
                  <Automatic16 />
                </TooltipIcon>
              ) : (
                ''
              )}
            </div>
          )}

          <div>{row.address}</div>
          {row.isLimitedReached ? (
            <div className="transactions-limit-reached-container">
              <div className="transactions-limit-reached row-item-aligment">
                <ViewOff16 />
                Unable to view
              </div>
            </div>
          ) : (
            <>
              <div className="status-container-small">
                {row.isExpired &&
                  REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true' && (
                    <div>
                      {row.allResponsesReceived
                        ? 'All responses received'
                        : 'Waiting for responses'}
                      &nbsp;
                    </div>
                  )}
                {REACT_APP_SENTINEL_RESPONSE_COLLATION === 'true' && (
                  <div
                    className={`${row.status} row-item-aligment ${
                      REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true'
                        ? row.status + '-old'
                        : ''
                    }`}
                  >
                    {row.status === 'fulfilled' &&
                      !row.archivedAt &&
                      !row.isExpired && <CheckmarkOutline16 />}
                    {row.status === 'waiting' &&
                      !row.archivedAt &&
                      !row.isExpired && <Hourglass16 />}
                    {row.isExpired && !row.archivedAt && <CloseOutline16 />}
                    {row.archivedAt && <Folder16 />}
                    {row.statusTranslated}
                  </div>
                )}

                {REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true' && (
                  <div
                    className={`${row.status} ${
                      REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true'
                        ? row.status + '-old'
                        : ''
                    }`}
                  >
                    {row.statusTranslated}
                    {row.autoRenew ||
                    (!row.internalCreate && row.autoRenewUntil)
                      ? ' (AR)'
                      : ''}
                  </div>
                )}
              </div>
              {row.isIgnore && (
                <div className="limit-reached">Free plan limit reached</div>
              )}
            </>
          )}
        </TableCell>
      ) : (
        <>
          <TableCell
            key={`${row.id}-1`}
            className={
              row.isExpired && REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true'
                ? 'expired-row'
                : ''
            }
          >
            {REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true' && (
              <div>{row.jobId}</div>
            )}
            {REACT_APP_SENTINEL_RESPONSE_COLLATION === 'true' && (
              <div className="jobId-row">
                {row.jobId}
                {row.autoRenew ||
                (!row.internalCreate && row.autoRenewUntil) ? (
                  <TooltipIcon
                    tooltipText={`Auto-renews until ${toLocalDateFormat(
                      row.autoRenewUntil
                    )}`}
                    align={'start'}
                  >
                    <Automatic16 />
                  </TooltipIcon>
                ) : (
                  ''
                )}
              </div>
            )}
            <div>{row.createdAt}</div>
            <div>{row.enquirer}</div>
          </TableCell>
          <TableCell
            key={`${row.id}-2`}
            className={
              row.isExpired && REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true'
                ? 'expired-row'
                : ''
            }
          >
            {row.userReference}
          </TableCell>
          <TableCell
            key={`${row.id}-3`}
            className={
              row.isExpired && REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true'
                ? 'expired-row'
                : ''
            }
          >
            {row.address}
          </TableCell>
          <TableCell
            key={`${row.id}-4`}
            className={
              row.isExpired && REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true'
                ? 'expired-row'
                : ''
            }
          >
            {row.isLimitedReached ? (
              <div className="transactions-limit-reached-container">
                <div className="transactions-limit-reached row-item-aligment">
                  <ViewOff16 />
                  Unable to view
                </div>
                <div className="transactions-limit-reached subtitle">
                  Maximum number of transactions reached
                </div>
              </div>
            ) : (
              <>
                {REACT_APP_SENTINEL_RESPONSE_COLLATION === 'true' && (
                  <div
                    className={`${row.status} row-item-aligment ${
                      REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true'
                        ? row.status + '-old'
                        : ''
                    }`}
                  >
                    {row.status === 'fulfilled' &&
                      !row.archivedAt &&
                      !row.isExpired && <CheckmarkOutline16 />}
                    {row.status === 'waiting' &&
                      !row.archivedAt &&
                      !row.isExpired && <Hourglass16 />}
                    {row.isExpired && !row.archivedAt && <CloseOutline16 />}
                    {row.archivedAt && <Folder16 />}
                    {row.statusTranslated}
                  </div>
                )}

                {REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true' && (
                  <>
                    {row.isExpired && (
                      <div>
                        {row.allResponsesReceived
                          ? 'All responses received'
                          : 'Waiting for responses'}
                      </div>
                    )}
                    <div
                      className={`${row.status} ${
                        REACT_APP_SENTINEL_RESPONSE_COLLATION !== 'true'
                          ? row.status + '-old'
                          : ''
                      }`}
                    >
                      {row.statusTranslated}
                      {!row.archivedAt &&
                      (row.autoRenew ||
                        (!row.internalCreate && row.autoRenewUntil))
                        ? ' (AR)'
                        : ''}
                    </div>
                  </>
                )}

                {row.isIgnore && (
                  <div className="limit-reached">Free plan limit reached</div>
                )}
              </>
            )}
          </TableCell>
        </>
      )}
    </TableRow>
  );
};

export default React.memo(DisplayEnquiryRow);
